module.exports = __webpack_public_path__ + "static/media/babyface.6143ef9c.png";